import React from 'react';
import { motion } from 'framer-motion';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Gallery } from './components/Gallery';
import { Footer } from './components/Footer';
import { Chatbot } from './components/Chatbot';
import { ShootingClipper } from './components/ShootingClipper';
export function App() {
  return <div className="min-h-screen bg-zinc-950 font-sans selection:bg-red-500/30 selection:text-red-200 relative overflow-hidden" data-id="element-0">
      {/* Decorative barber clipper streaking across the screen like a shooting star */}
      <ShootingClipper data-id="element-1" />

      {/* Navigation (Simple transparent header) */}
      <header className="absolute top-0 left-0 w-full z-50 py-6" data-id="element-2">
        <div className="container mx-auto px-6 flex items-center justify-between" data-id="element-3">
          <div className="relative" data-id="element-4">
            {/* Red aura glow behind the wordmark */}
            <motion.div aria-hidden="true" animate={{
            opacity: [0.4, 0.85, 0.4],
            scale: [1, 1.15, 1]
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute -inset-3 rounded-full bg-red-600/50 blur-2xl" data-id="element-5" />
            <motion.div animate={{
            filter: ['drop-shadow(0 0 10px rgba(220,38,38,0.5))', 'drop-shadow(0 0 26px rgba(220,38,38,0.95))', 'drop-shadow(0 0 10px rgba(220,38,38,0.5))']
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="relative font-brush text-4xl text-zinc-50 leading-none" data-id="element-6">
              Okrim
            </motion.div>
          </div>
          <motion.button onClick={() => window.open('https://wa.me/59892738664?text=Hola%20Okrim!%20Quería%20agendar%20un%20turno.', '_blank')} animate={{
          boxShadow: ['0 0 12px rgba(220,38,38,0.4)', '0 0 26px rgba(220,38,38,0.85)', '0 0 12px rgba(220,38,38,0.4)']
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'easeInOut'
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.96
        }} className="px-5 py-2.5 rounded-full bg-red-600 hover:bg-red-500 text-zinc-50 text-sm font-semibold tracking-wide transition-colors" data-id="element-7">
            Reservar Turno
          </motion.button>
        </div>
      </header>

      <main data-id="element-8">
        <Hero data-id="element-9" />
        <Services data-id="element-10" />
        <Gallery data-id="element-11" />
      </main>

      <Footer data-id="element-12" />

      {/* The $3000 Value Feature */}
      <Chatbot data-id="element-13" />
    </div>;
}